import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const DELETE_PAYROLL_EMPLOYEE_REQUEST =
  "DELETE_PAYROLL_EMPLOYEE_REQUEST";
export const DELETE_PAYROLL_EMPLOYEE_SUCCESS =
  "DELETE_PAYROLL_EMPLOYEE_SUCCESS";
export const DELETE_PAYROLL_EMPLOYEE_ERROR = "DELETE_PAYROLL_EMPLOYEE_ERROR";

//* ACTIONS ------------------------------------------------
export const deletePayrollEmployeeRequest = (payload = {}, callback) => ({
  type: DELETE_PAYROLL_EMPLOYEE_REQUEST,
  payload,
  callback,
});

export const deletePayrollEmployeeSuccess = () => ({
  type: DELETE_PAYROLL_EMPLOYEE_SUCCESS,
});

export const deletePayrollEmployeeError = (error) => ({
  type: DELETE_PAYROLL_EMPLOYEE_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const deletePayrollEmployeeServiceRequest = async ({
  payrollId,
  employeeId,
}) => {
  const options = await withToken({
    method: Methods.DELETE,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/payrolls/${payrollId}/employees/${employeeId}`, options);
};
